export function getThumbnailUrl(page) {
  const root = process.env.VUE_APP_CLOUDFRONT_ORIGIN || 'VUE_APP_CLOUDFRONT_ORIGIN_ENV_VAR_IS_MISSING'
  const transformationInfix = '/image/fetch/w_600/'
  const url = root + transformationInfix + page.pictureUrl
  return url
}
